<div versionChangesCheckbox class="version-changes-check-container" *ngIf="showToggle$ | async">
    <label class="checkbox-inline">
        <input type="checkbox" class="custom-control-input" [checked]="isShowingVersionChanges$ | async"
            (click)="toggleVersionComparison()"> <span i18n="@@phx.comparisonToggle.showVersionChanges">
            Show changes from previous version</span>
    </label>
</div>